import type { TFunction } from "i18next";
import type { TenantApp } from "../state/auth-store";

const appTranslationKeys: Record<string, string> = {
  admin: "admin",
  "time-tracking": "timeTracking",
  "human-resources": "humanResources",
  accounting: "accounting",
  invoice: "invoice",
};

const categoryTranslationKeys: Record<string, string> = {
  platform: "platform",
  system: "platform",
  sistema: "platform",
  operations: "operations",
  operaciones: "operations",
  people: "people",
  personas: "people",
  finance: "finance",
  finanzas: "finance",
};

const translateWithFallback = (
  t: TFunction<"layout">,
  key: string | undefined,
  fallback: string,
) => (key ? t(key, { defaultValue: fallback }) : fallback);

export const getLocalizedAppName = (
  t: TFunction<"layout">,
  app: Pick<TenantApp, "key" | "name">,
) => {
  const appKey = appTranslationKeys[app.key];
  return translateWithFallback(
    t,
    appKey ? `apps.${appKey}.name` : undefined,
    app.name,
  );
};

export const getLocalizedAppDescription = (
  t: TFunction<"layout">,
  app: Pick<TenantApp, "key" | "description">,
) => {
  const appKey = appTranslationKeys[app.key];
  return translateWithFallback(
    t,
    appKey ? `apps.${appKey}.description` : undefined,
    app.description,
  );
};

export const getLocalizedAppCategory = (
  t: TFunction<"layout">,
  category?: string,
) => {
  if (!category) {
    return t("launcher.defaultCategory");
  }

  const categoryKey = categoryTranslationKeys[category.trim().toLowerCase()];
  return translateWithFallback(
    t,
    categoryKey ? `categories.${categoryKey}` : undefined,
    category,
  );
};
